import {
  combineReducers,
  PayloadAction,
  SliceCaseReducers,
} from '@reduxjs/toolkit';
import { getLocalizationList } from './localization.action';
import { createCustomSlice } from '../store.utils';
import {
  getLocalizationInitialState,
  LOCALE_LOCAL_STORAGE_KEY,
} from './localization.constants';
import { TVocabularyGetListLocalePath } from 'api/localization/localization.types';
import { TLocalizationData } from './localization.types';
import { TAsyncThunkData } from 'store/store.types';
import { ESupportedLocales } from './localization.enums';
import { safelySetItem } from 'utils/localStorage';

// ---------- LIST ----------
const localization = createCustomSlice<
  TLocalizationData,
  { locale?: TVocabularyGetListLocalePath },
  unknown,
  SliceCaseReducers<TAsyncThunkData<TLocalizationData>>
>(
  'localization/localization',
  getLocalizationList,
  {
    changeLocale: (state, action: PayloadAction<ESupportedLocales>) => {
      if (action.payload === state.data.locale) return;
      safelySetItem(LOCALE_LOCAL_STORAGE_KEY, action.payload);
      state.data.locale = action.payload;
    },
  },
  {},
  getLocalizationInitialState() as TAsyncThunkData<TLocalizationData>
);

export const { changeLocale: changeLocaleAction } = localization.actions;

export const localizationReducer = combineReducers({
  localization: localization.reducer,
});
